import {
    Accordion,
    AccordionDetails,
    Autocomplete,
    Backdrop,
    Box,
    Button,
    Checkbox,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
    Tooltip,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { getShifts } from "../../store/actions/ShiftActions";
import {
    AccountCircle,
    ArrowBackIos,
    CheckCircle,
    CloudDownload,
    CloudUpload,
    NoteAdd,
    OfflinePin,
    PauseCircleFilled,
    People,
    PersonAdd,
    PlayCircleFilledWhite,
    RecordVoiceOver,
    Save,
    Assignment,
    Timelapse,
} from "@mui/icons-material";
import "moment/locale/tr";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { tr } from "date-fns/esm/locale";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import DocumentPopup from "../../components/Popup/DocumentPopup";
import TimelinePopup from "../../components/Popup/TimelinePopup";
import RequestCard from "../../components/RequestCard/RequestCard";
import CloseIcon from "@mui/icons-material/Close";
import DialogContentText from "@mui/material/DialogContentText";
import moment from "moment";
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    getEkedEquipmentList,
    updateEkedEquipmentList,
    getSameLevelListById,
    getTaskDetailById,
    getbreakdownRootCause,
    getPoolList,
    getBreakdownReasonGroupList,
    getTechnicianListByPoolId,
    plannedMaintenanceAssign,
    getPlannedMaintenance,
    plannedMaintenancePause,
    plannedMaintenanceCloaseComplete,
    plannedMaintenanceUpdateTask,
    AddTechnician,
    BreakdownReasonPlaceByGroupId,
    BreakdownReasonDetail,
    MaintenancePauseReason,
    getTaskHistoryById,
    getPlannedFiles,
    deleteTask,
    deletePlannedFiles,
    addPlannedFiles,
} from "../../store/actions/PlannedMaintenanceDetailActions";
import { getEquipmentFiles, deleteEquipmentFiles } from "../../store/actions/EquipmentAction";
import { getSparePartList } from "../../store/actions/SparePartActions";
import SecurityPopup from "../../components/Popup/SecurityPopup";
import { getFormDataFromFiles, getSelectedFileNames } from "../../common";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import Shift from "../../components/Dropdowns/Shift";

const useStyles = makeStyles((theme) => ({
    colorized: {
        width: 20,
        height: 20,
    },
    speedDial: {
        position: "absolute",
        bottom: theme.spacing(4),
        right: theme.spacing(2),
    },
    backdrop: {
        zIndex: 1,
        color: "#fff",
    },
    iconButtonLabel: {
        display: "flex",
        flexDirection: "column",
    },
    popupElement: {
        width: "100%",
        marginTop: 10,
    },
}));

const iconButtonStyle = {
    width: 50,
    height: 50,
    padding: 0,
};

const useStylesTooltip = makeStyles((theme) => ({
    staticTooltipLabel: {
        fontSize: 13,
        fontWeight: "bold",
        width: 160,
    },
}));

export default function PlannedMaintenanceDetail(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const PlannedMaintenanceDetail = useSelector((state) => state.PlannedMaintenanceDetail);
    const { equipment } = useSelector((state) => state);
    const classes = useStyles();
    const classTooltip = useStylesTooltip();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [userID, setUserID] = useState();
    const { t } = useTranslation("translation");
    const [securityDialogOpen, setSecurityDialogOpen] = useState(false);
    const [startPayload, setStartPayload] = useState(null);
    const [disableTaskCheckItemsButton, setDisableTaskCheckItemsButton] = useState(false);

    const [selectedEkedEquipmentIds, setSelectedEkedEquipmentIds] = useState([]);
    const [selectedEkedEquipmentNames, setSelectedEkedEquipmentNames] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [ekedUsed, setEkedUsed] = useState(false);
    const [tempEkedEquipmentNames, setTempEkedEquipmentNames] = useState([]);
    const [tempEkedEquipmentIds, setTempEkedEquipmentIds] = useState([]);
    const [disabledEked, setDisabledEked] = useState(false);
    const [isEnvNotClean, setIsEnvNotClean] = useState(false);
    const [hasSparePart, setHasSparePart] = useState(false);
    const [selectedShiftNo, setSelectedShiftNo] = useState("");
    const [selectedShiftType, setSelectedShiftType] = useState("");
    const [userIList, setUserIList] = useState([]);

    const { sparePartList } = useSelector(({ SparePart }) => SparePart);
    const { shiftList } = useSelector(({ Shifts }) => Shifts);
    const {
        user: { userInterfaceList },
    } = useSelector((user) => user);

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserID(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", ""));
        loadHandler();
        fetchSparePart();
    }, []);

    useEffect(() => {
        if (sparePartList?.resultObject?.totalCount > 0) {
            setHasSparePart(true);
        }
    }, [sparePartList]);

    const fetchSparePart = () => {
        let payload = {
            currentPage: 1,
            pageSize: 10,
            searchText: "",
            propertyName: "",
            direction: 1,
        };
        dispatch(getSparePartList(payload));
    };

    useEffect(() => {
        if (userInterfaceList?.resultObject) {
            let interfaceList = userInterfaceList?.resultObject?.interfaceList;
            setUserIList(interfaceList);
        }
    }, [userInterfaceList]);

    //load shift data
    let [shiftData, setShiftData] = useState([]);
    useEffect(() => {
        if (shiftList?.resultObject?.length > 0) {
            setShiftData(shiftList.resultObject[0].shifts);
            console.log(shiftList.resultObject[0].shifts);
        }
    }, [shiftList]);

    useEffect(() => {
        if (PlannedMaintenanceDetail.taskDetailById) {
            handlePlannedDateChange(PlannedMaintenanceDetail.taskDetailById.plannedDate);
            genericLoadRows(PlannedMaintenanceDetail.taskDetailById);
            setIsChecked(PlannedMaintenanceDetail.taskDetailById.isEkedUsed);
            setEkedUsed(PlannedMaintenanceDetail.taskDetailById.isEkedUsed);
            setIsEnvNotClean(PlannedMaintenanceDetail.taskDetailById.isEnvNotClean);
            setSelectedShiftType(PlannedMaintenanceDetail.taskDetailById.shiftNo);
            setPageLoaded(true);
            if (PlannedMaintenanceDetail.taskDetailById.isEkedUsed) {
                const id = queryString.parse(window.location.search).id;
                dispatch(getEkedEquipmentList(id));
            }
            PlannedMaintenanceDetail.taskDetailById = null;
        }
    }, [PlannedMaintenanceDetail.taskDetailById]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.taskEkedList?.resultObject && isChecked) {
            setSelectedEkedEquipmentIds(PlannedMaintenanceDetail.taskEkedList.resultObject.map((item) => item.ekedEquipmentId));
            setTempEkedEquipmentIds(PlannedMaintenanceDetail.taskEkedList.resultObject.map((item) => item.ekedEquipmentId));
        }
    }, [PlannedMaintenanceDetail.taskEkedList]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.poolList?.resultObject) {
            setPoolData(PlannedMaintenanceDetail.poolList.resultObject);
        }
    }, [PlannedMaintenanceDetail.poolList]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.breakdownReasonGroupList?.loadBreakdownReasonGroup) {
            setBreakdownReasonGroupDataFilter(PlannedMaintenanceDetail.breakdownReasonGroupList.resultObject);
            setBreakdownDetailPopup(true);
        }
        if (PlannedMaintenanceDetail?.breakdownReasonGroupList?.loadEditRequestData) {
            setBreakDownReasonGroupData(PlannedMaintenanceDetail.breakdownReasonGroupList.resultObject);
        }
    }, [PlannedMaintenanceDetail.breakdownReasonGroupList]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.breakdownEffectList?.resultObject) {
            setBreakdownEffectData(PlannedMaintenanceDetail.breakdownEffectList.resultObject);
            setEditRequestPopup(true);
            dispatch(getShifts());
        }
    }, [PlannedMaintenanceDetail.breakdownEffectList]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.technicianListByPoolId) {
            setUserData(Object.values(PlannedMaintenanceDetail.technicianListByPoolId));
            loadAddFriendUserData(rows, Object.values(PlannedMaintenanceDetail.technicianListByPoolId), rows.techList);
        }
    }, [PlannedMaintenanceDetail.technicianListByPoolId]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.plannedMaintenanceAssign) {
            setAssignPopup(false);
            PlannedMaintenanceDetail.plannedMaintenanceAssign = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.plannedMaintenanceAssign]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.plannedMaintenance) {
            PlannedMaintenanceDetail.plannedMaintenance = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.plannedMaintenance]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.error) {
            PlannedMaintenanceDetail.error = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.error]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.setPlannedMaintenanceCloaseComplete) {
            PlannedMaintenanceDetail.setPlannedMaintenanceCloaseComplete = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.setPlannedMaintenanceCloaseComplete]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.plannedMaintenancePause) {
            PlannedMaintenanceDetail.plannedMaintenancePause = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.plannedMaintenancePause]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.plannedMaintenanceUpdateTask) {
            PlannedMaintenanceDetail.plannedMaintenanceUpdateTask = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.plannedMaintenanceUpdateTask]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.AddTechnician) {
            PlannedMaintenanceDetail.AddTechnician = null;
            loadHandler();
        }
    }, [PlannedMaintenanceDetail.AddTechnician]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.breakdownReasonPlaceByGroupId) {
            setBreakdownReasonPlace(PlannedMaintenanceDetail.breakdownReasonPlaceByGroupId);
        }
    }, [PlannedMaintenanceDetail.breakdownReasonPlaceByGroupId]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.BreakdownReasonDetail) {
            setSelectedBreakdownReasonDetailCode(PlannedMaintenanceDetail.BreakdownReasonDetail.resultObject[0].id);
            setSelectedBreakdownReasonDetailName(PlannedMaintenanceDetail.BreakdownReasonDetail.resultObject[0].name);
        }
    }, [PlannedMaintenanceDetail.BreakdownReasonDetail]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.plannedFiles) {
            setDocumentList(PlannedMaintenanceDetail.plannedFiles);
            PlannedMaintenanceDetail.plannedFiles = null;
        }
    }, [PlannedMaintenanceDetail.plannedFiles]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.maintenancePauseReason) {
            setMaintenancePauseReasonData(Object.values(PlannedMaintenanceDetail.maintenancePauseReason.resultObject));
            setPausePopup(true);
            PlannedMaintenanceDetail.maintenancePauseReason = null;
        }
    }, [PlannedMaintenanceDetail.maintenancePauseReason]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.setTaskHistoryById) {
            setTimelineArray(Object.values(PlannedMaintenanceDetail.setTaskHistoryById.resultObject));
        }
    }, [PlannedMaintenanceDetail.setTaskHistoryById]);

    useEffect(() => {
        if (PlannedMaintenanceDetail?.deleteTask) {
            props.history.goBack();
            PlannedMaintenanceDetail.deleteTask = null;
        }
    }, [PlannedMaintenanceDetail.deleteTask]);

    // Get Equipment Files
    useEffect(() => {
        if (equipment?.equipmentFiles) {
            setEquipmentFiles(equipment.equipmentFiles);
            setDocumentPopup(true);
            equipment.equipmentFiles = null;
        }
    }, [equipment]);

    const [rows, setRows] = useState([]);
    const [plannedDate, setPlannedDate] = useState();

    //spare part
    const HandleSparePart = (event) => {
        setSparePart(event.target.value);
    };

    const loadHandler = () => {
        dispatch(getTaskDetailById(queryString.parse(window.location.search).id));
    };

    //generic function to load row data
    const genericLoadRows = (result) => {
        setRows(result);
        handleDisableParts(result.taskStatus);
        loadUserData(result);
        //set default values
        setSelectedPoolCode(result.poolId);
        setSelectedBreakdownReasonDetailCode(result.breakdownReasonDetailId);
        setSelectedBreakdownReasonGroupCode(result.breakdownReasonGroupId);
        setSelectedBreakdownEffectCode(result.breakdownEffectId);
        setSelectedBreakdownRootCauseCode(result.breakdownRootCauseId);
        setSelectedEquipment(result.equipmentId);
        setNotes(result.notes);
        setSparePart(result.freeTxt1);
        setSelectedBreakdownReasonPlaceName(result.breakdownTaskPlaceName);
        setSelectedBreakdownReasonDetailName(result.breakdownReasonDetailName);
    };

    //load detail data for popup
    let [breakdownReasonGroupData, setBreakDownReasonGroupData] = useState([]);
    let [poolData, setPoolData] = useState([]);
    let [breakdownEffectData, setBreakdownEffectData] = useState([]);
    const [editRequestPopup, setEditRequestPopup] = useState(false);
    const loadEditRequestData = () => {
        dispatch(getPoolList({ loadEditRequestData: true }));
    };

    const HandleSparePartOpen = () => {
        props.history.push("/add-spare-part?id=" + rows.id, { taskId: rows.id, type: "planned" });
    };

    //load user data for popup
    const [assignPopup, setAssignPopup] = useState(false);
    let [userData, setUserData] = useState([]);
    const loadUserData = (rows) => {
        dispatch(getTechnicianListByPoolId(rows.poolId));
    };

    //go breakdown detail page
    const backToBreakdownListPage = () => {
        props.history.goBack();
    };

    //set breakdown root cause
    let [selectedBreakdownRootCauseCode, setSelectedBreakdownRootCauseCode] = useState();

    //speed dial
    const [openSpeedDial, setOpenSpeedDial] = useState(false);
    const handleOpenSpeedDial = (data) => {
        //for completed, closed, canceled status, it should be disabled
        if (data.taskStatus != 5 && data.taskStatus != 6 && data.taskStatus != 7) {
            setOpenSpeedDial(true);
        }
    };

    const handleCloseSpeedDial = () => {
        setOpenSpeedDial(false);
    };

    //edit request details
    //set breakdownReasonGroupCode
    let [selectedBreakdownReasonGroupCode, setSelectedBreakdownReasonGroupCode] = useState();

    //set poolCode
    let [selectedPoolCode, setSelectedPoolCode] = useState();
    const handlePoolChange = (event) => {
        setSelectedPoolCode(event.target.value);
    };

    //set breakdownEffectCode
    let [selectedBreakdownEffectCode, setSelectedBreakdownEffectCode] = useState();

    const openEditRequest = () => {
        setOpenSpeedDial(false);
        setPlannedDate(new Date());
        loadEditRequestData();
    };

    const cancelEditRequest = () => {
        setSelectedPoolCode(rows.poolId);
        setSelectedBreakdownReasonGroupCode(rows.breakdownReasonGroupId);
        setSelectedBreakdownEffectCode(rows.breakdownEffectId);
        setEditRequestPopup(false);
    };

    //add friend popup
    //set userCode
    let [selectedUserCode, setSelectedUserCode] = useState();
    const handleUserChange = (userName) => {
        if (userName != null) {
            const filteredUserName = userData.filter((item) => item.userName.includes(userName));
            setSelectedUserCode(filteredUserName[0].userCode);
        }
    };

    const HandleShift = (shiftNo) => {
        if (shiftNo != null) {
            const filteredType = shiftData.filter((item) => item.shiftNo == shiftNo);
            setSelectedShiftNo(filteredType[0].id);
            setSelectedShiftType(filteredType[0].shiftNo.toString());
            return filteredType[0].id;
        } else {
            setSelectedShiftNo(0);
            setSelectedShiftType("");
        }
    };

    const openAssign = () => {
        setOpenSpeedDial(false);
        setAssignPopup(true);
    };

    const cancelAssign = () => {
        setSelectedUserCode();
        setAssignPopup(false);
    };

    //assign to me
    const assignToMe = (rowData) => {
        let payload = {
            id: rowData.id,
            userID,
        };
        dispatch(plannedMaintenanceAssign(payload));
    };

    //assign to someone
    const assignToSomeone = (rowData) => {
        let payload = {
            id: rowData.id,
            userID: selectedUserCode,
        };
        dispatch(plannedMaintenanceAssign(payload));

        setAssignPopup(false);
    };

    const EkedEquipmentPopupHandler = () => {
        setSecurityDialogOpen(true);
    };

    //start task
    const startTask = (rowData) => {
        setSecurityDialogOpen(true);
        setDisabledEked(false);
        //continue task
        if (rowData.taskStatus == 4) {
            let payload = {
                id: rowData.id,
                task: "Play",
            };
            setStartPayload(payload);
            //dispatch(getPlannedMaintenance(payload));
        }
        //start task
        else {
            let payload = {
                id: rowData.id,
                task: "Start",
            };
            setStartPayload(payload);
            //dispatch(getPlannedMaintenance(payload));
        }
    };

    const HandleEkedEquipment = (equipments) => {
        let ids = [];
        let names = [];
        equipments.map((item) => ids.push(item.id));
        equipments.map((item) => names.push(item.name));
        if (equipments == null) {
            setTempEkedEquipmentIds([]);
            setTempEkedEquipmentNames([]);
        } else {
            setTempEkedEquipmentIds(ids);
            setTempEkedEquipmentNames(names);
        }
    };

    const HandleSecurityDialogClose = () => {
        setIsChecked(ekedUsed);
        setTempEkedEquipmentIds(selectedEkedEquipmentIds);
        setTempEkedEquipmentNames(selectedEkedEquipmentNames);
        setSecurityDialogOpen(false);
        if (startPayload) {
            dispatch(getPlannedMaintenance(startPayload));
            setStartPayload(null);
        }
    };

    const HandleSecurityDialogConfirm = () => {
        setEkedUsed(isChecked);
        setSelectedEkedEquipmentIds(tempEkedEquipmentIds);
        setSelectedEkedEquipmentNames(tempEkedEquipmentNames);
        const id = queryString.parse(window.location.search).id;
        let data = {
            taskId: id,
            ekedUsed: isChecked,
            payload: tempEkedEquipmentIds,
        };

        setSecurityDialogOpen(false);
        dispatch(updateEkedEquipmentList(data));
        if (startPayload) {
            setTimeout(() => {
                dispatch(getPlannedMaintenance(startPayload));
                setStartPayload(null);
            }, 500);
        }
    };

    //complete task
    const completeTask = (rowData) => {
        const data = {
            id: rowData.id,
            maintenanceOrderId: rowData.maintenanceOrderId,
            equipmentId: selectedEquipment,
            notes: notes,
            breakdownReasonDetailId: selectedBreakdownReasonDetailCode,
            breakdownRootCauseId: selectedBreakdownRootCauseCode,
            breakdownEffectId: selectedBreakdownEffectCode,
            FreeTxt1: sparePart,
            poolId: selectedPoolCode,
            isEnvNotClean: isEnvNotClean,
        };
        if (rowData.taskStatus == 5) {
            let payload = {
                data,
                task: "Close",
            };
            dispatch(plannedMaintenanceCloaseComplete(payload));
        } else {
            let payload = {
                data,
                task: "Complete",
            };
            dispatch(plannedMaintenanceCloaseComplete(payload));
        }
    };

    //pause task
    const pauseTask = (rowData) => {
        let payload = {
            id: rowData.id,
            selectedMaintenancePauseReasonCode,
            maintenancePauseNote,
        };
        dispatch(plannedMaintenancePause(payload));

        setPausePopup(false);
    };

    //update task
    const updateTask = (rowData) => {
        const data = {
            id: rowData.id,
            maintenanceOrderId: rowData.maintenanceOrderId,
            equipmentId: selectedEquipment,
            shiftNo: parseInt(selectedShiftType),
            poolId: selectedPoolCode,
            notes: notes,
            plannedDate: plannedDate,
            FreeTxt1: sparePart,
        };
        dispatch(plannedMaintenanceUpdateTask(data));

        setEditRequestPopup(false);
    };

    const [openCancelTaskPopup, setOpenCancelTaskPopup] = useState(false);
    const openCancelPopup = () => {
        setOpenSpeedDial(false);
        setOpenCancelTaskPopup(true);
    };

    const closeCancelPopup = () => {
        setOpenCancelTaskPopup(false);
    };

    const [openAddFriendPopup, setOpenAddFriendPopup] = useState(false);
    const openAddFriend = () => {
        setOpenAddFriendPopup(true);
    };

    const closeAddFriendPopup = () => {
        setOpenAddFriendPopup(false);
    };

    const OpenEquipmentNotes = () => {
        history.push("equipment-notes?id=" + rows.equipmentId, { equipmentId: rows.equipmentId, equipmentName: rows.equipmentName });
    };

    //set speed dial paramteters
    const actions = [
        { icon: <People />, name: t("EditJobOrder"), action: openEditRequest },
        { icon: <PersonAdd />, name: t("AssigntoAnotherPerson"), action: openAssign },
        { icon: <CloseIcon />, name: t("CancelCall"), action: openCancelPopup },
        { icon: <RecordVoiceOver />, name: t("AddFriend"), action: openAddFriend },
        { icon: <NoteAdd />, name: t("EquipmentNotes"), action: OpenEquipmentNotes },
        // { icon: <Add />, name: 'Alt Çağrı Aç', action: openCreateSubtask },
    ];

    const [selectedFriend, setSelectedFriend] = useState();
    const addFriend = (rowData) => {
        let payload = {
            id: rowData.id,
            selectedFriend,
        };
        dispatch(AddTechnician(payload));
    };

    let [addFriendUserData, setAddFriendUserData] = useState(null);
    const loadAddFriendUserData = (rows, userData, techList) => {
        let list = [];
        if (techList) {
            for (let i = 0; i < userData.length; i++) {
                let addUser = true;
                for (let j = 0; j < techList.length; j++) {
                    if (techList[j].userCode.toLowerCase() == userData[i].userCode.toLowerCase()) {
                        addUser = false;
                    }
                }
                if (userData[i].userName == rows.assigneeName) {
                    addUser = false;
                }
                if (addUser) {
                    list.push(userData[i]);
                }
            }
        }
        setAddFriendUserData(list);
    };

    //notes
    const [notes, setNotes] = useState("");
    const handleNotes = (event) => {
        setNotes(event.target.value);
    };

    //spare part
    const [sparePart, setSparePart] = useState("");
    const handleSparePart = (event) => {
        setSparePart(event.target.value);
    };

    //load breakdown reason group data for popup
    let [breakdownReasonGroupDataFilter, setBreakdownReasonGroupDataFilter] = useState([]);
    const loadBreakdownReasonGroup = () => {
        dispatch(getBreakdownReasonGroupList({ loadBreakdownReasonGroup: true }));
    };

    let [selectedBreakdownReasonGroupFilter, setSelectedBreakdownReasonGroupFilter] = useState([]);
    const handleBreakdownReasonGroupFilter = (event) => {
        setSelectedBreakdownReasonGroupFilter(event.target.value);
        loadBreakdownReasonPlace(event.target.value);
    };

    //load breakdown place data filtered by breakdown reason group
    let [breakdownReasonPlace, setBreakdownReasonPlace] = useState([]);
    const loadBreakdownReasonPlace = (data) => {
        dispatch(BreakdownReasonPlaceByGroupId(data));
    };

    let [selectedBreakdownReasonPlaceCode, setSelectedBreakdownReasonPlaceCode] = useState([]);
    let [selectedBreakdownReasonPlaceName, setSelectedBreakdownReasonPlaceName] = useState();
    const handleBreakdownReasonPlace = (event) => {
        setSelectedBreakdownReasonPlaceCode(event.target.value);
        setSelectedBreakdownReasonPlaceName(breakdownReasonPlace.filter((item) => item.id === event.target.value)[0].name);
        loadBreakdownReasonDetail(event.target.value);
    };

    //load breakdown place data filtered by breakdown reason group
    let [breakdownReasonDetail, setBreakdownReasonDetail] = useState([]);
    const loadBreakdownReasonDetail = (data) => {
        dispatch(BreakdownReasonDetail(data));
    };

    //set breakdown reason detail
    let [selectedBreakdownReasonDetailCode, setSelectedBreakdownReasonDetailCode] = useState();
    let [selectedBreakdownReasonDetailName, setSelectedBreakdownReasonDetailName] = useState();
    const handleBreakdownReasonDetail = (event) => {
        setSelectedBreakdownReasonDetailCode(event.target.value);
        setSelectedBreakdownReasonDetailName(breakdownReasonDetail.filter((item) => item.id === event.target.value)[0].name);
    };

    //set root equipment
    let [selectedEquipment, setSelectedEquipment] = useState([]);
    const handleEquipment = (event) => {
        setSelectedEquipment(event.target.value);
    };

    //breakdown detail popup
    const [breakdownDetailPopup, setBreakdownDetailPopup] = useState(false);
    const handleBreakdownDetailOpen = () => {
        loadBreakdownReasonGroup();
    };
    const handleBreakdownDetailClose = () => {
        setBreakdownDetailPopup(false);
    };

    //disable enable buttons
    const [disableNote, setDisableNote] = useState(false);
    const [disableSparePart, setDisableSparePart] = useState(false);
    const [disableDocumentButton, setDisableDocumentButton] = useState(false);
    const [disableAssignButton, setDisableAssignButton] = useState(false);
    const [disableStartButton, setDisableStartButton] = useState(false);
    const [disableFinishButton, setDisableFinishButton] = useState(false);
    const [disablePauseButton, setDisablePauseButton] = useState(false);
    const [disableEnvCheckbox, setDisableEnvCheckbox] = useState(false);

    const disable = (list) => {
        setDisableNote(list[2]);
        setDisableSparePart(list[4]);
        setDisableDocumentButton(list[5]);
        setDisableAssignButton(list[6]);
        setDisableStartButton(list[7]);
        setDisableFinishButton(list[8]);
        setDisablePauseButton(list[9]);
        setDisableTaskCheckItemsButton(list[10]);
        setDisabledEked(list[11]);
        setDisableEnvCheckbox(list[12]);
    };

    // Handle Visibilities
    const [visibleNote, setVisibleNote] = useState(false);
    const [visibleSparePart, setVisibleSparePart] = useState(false);
    const [visibleEnvCheckbox, setVisibleEnvCheckbox] = useState(false);

    const Visible = (list) => {
        setVisibleNote(list[0]);
        setVisibleSparePart(list[1]);
        setVisibleEnvCheckbox(list[2]);
    };

    //enable disable for status
    const handleDisableParts = (status) => {
        //Atama Bekliyor
        if (status === 1) {
            disable([true, true, true, true, true, true, false, true, true, true, false, true, true]);
            Visible([false, false, false]);
        }

        //Atandı
        else if (status === 2) {
            disable([true, true, true, true, true, true, false, false, true, true, false, true, true]);
            Visible([false, false, false]);
        }

        //Başlandı
        else if (status === 3) {
            disable([false, false, false, false, false, false, true, true, false, false, false, false, false]);
            Visible([true, true, true]);
        }

        //Durduruldu
        else if (status === 4) {
            disable([true, true, true, true, true, true, true, false, true, true, false, true, true]);
            Visible([false, false, false]);
        }

        //Tamamlandı
        else if (status === 5) {
            disable([false, false, false, false, false, false, true, false, false, false, false, false, true]);
            Visible([true, true, true]);
        }

        //Kapandı
        else if (status === 6) {
            disable([true, true, true, true, true, true, true, true, true, true, false, true, true]);
            Visible([true, true, true]);
        }

        //İptal Edildi
        else if (status === 7) {
            disable([true, true, true, true, true, true, true, true, true, true, true, true, true]);
            Visible([true, true, true]);
        }
    };

    // File Management
    const [documentPopup, setDocumentPopup] = useState(false);
    let [documentList, setDocumentList] = useState([]);
    const [equipmentFiles, setEquipmentFiles] = useState([]);

    const handleDocumentOpen = () => {
        dispatch(getPlannedFiles(rows.maintenanceOrderId));
        dispatch(getEquipmentFiles(rows.equipmentId));
    };
    const closeDocumentPopup = () => {
        setDocumentPopup(false);
    };

    const DeleteFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            plannedId: rows.maintenanceOrderId,
            fileNames: selectedFileNames,
        };
        dispatch(deletePlannedFiles(payload));
        setDocumentPopup(false);
    };

    const DeleteEquipmentFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            equipmentId: rows.equipmentId,
            fileNames: selectedFileNames,
        };
        dispatch(deleteEquipmentFiles(payload));
        setDocumentPopup(false);
    };

    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const UploadFiles = (files) => {
        const formData = getFormDataFromFiles(files);
        const payload = {
            plannedId: rows.maintenanceOrderId,
            data: formData,
        };
        dispatch(addPlannedFiles(payload));
        setIsFileUploaderPopupOpen(false);
    };

    //timeline popup
    const [timelinePopup, setTimelinePopup] = useState(false);
    const closeTimelinePopup = () => {
        setTimelinePopup(false);
    };

    const [timelineArray, setTimelineArray] = useState([]);
    const handleTimelineOpen = () => {
        setTimelinePopup(true);
        let payload = {
            id: rows.id,
        };
        dispatch(getTaskHistoryById(payload));
    };

    const HandleOrderFormOpen = () => {
        let createDate = moment(rows.createdDate).format("DD.MM.YYYY");
        let data = {
            maintenanceOrderId: rows.maintenanceOrderId,
            equipmentName: rows.equipmentName,
            createdDate: createDate,
            notes: rows.notes,
            plannedMaintenance: true,
        };
        props.history.push("/order-form?id=" + rows.id, data);
    };

    //pause popup
    const [pausePopup, setPausePopup] = useState(false);
    const [maintenancePauseReasonData, setMaintenancePauseReasonData] = useState([]);
    const openPausePopup = () => {
        dispatch(MaintenancePauseReason());
    };
    const closePausePopup = () => {
        setPausePopup(false);
    };

    //set breakdown pause detail
    let [selectedMaintenancePauseReasonCode, setSelectedMaintenancePauseReasonCode] = useState(0);
    const handleMaintenancePauseReason = (pauseName) => {
        if (pauseName != null) {
            const filteredPauseReason = maintenancePauseReasonData.filter((item) => item.name.includes(pauseName));
            setSelectedMaintenancePauseReasonCode(filteredPauseReason[0].id);
            return filteredPauseReason[0].id;
        }
    };

    const [maintenancePauseNote, setMaintenancePauseNote] = useState("");
    const handleMaintenancePauseNote = (event) => {
        setMaintenancePauseNote(event.target.value);
    };

    const handlePlannedDateChange = (date) => {
        setPlannedDate(moment(date).format("YYYY-MM-DD"));
    };

    const deleteOnce = () => {
        let payload = {
            id: queryString.parse(window.location.search).id,
            flag: "false",
        };
        dispatch(deleteTask(payload));
    };

    const deleteAll = () => {
        let payload = {
            id: queryString.parse(window.location.search).id,
            flag: "true",
        };
        dispatch(deleteTask(payload));
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Container id="pmd_Container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                    <Grid container alignItems="center" id="pmd_Grid">
                        <Grid item xs={1} id="pmd_Grid_1">
                            <IconButton id="pmd_iconButton" onClick={backToBreakdownListPage} size="large">
                                <ArrowBackIos fontSize="inherit" align="end" />
                            </IconButton>
                        </Grid>
                        <Grid item xs={11} id="pmd_Grid_2">
                            <Typography variant="h6" gutterBottom style={{ fontSize: 15 }}>
                                {rows.equipmentDetailedCode}
                            </Typography>
                        </Grid>
                    </Grid>

                    <RequestCard id="pmd_RequestCard" rows={[rows]} detail={true} page="plannedmaintenanceDetail" taskName="Task" callName="Plan" isPlannedMaintenance={true} />
                    {userIList.includes("VIEWER") ? null : (
                        <Box id="pmd_Box" pt={1} pb={1} style={{ marginTop: 10 }} border={1} borderRadius="10px">
                            <Grid container id="pmd_Grid_3">
                                {visibleNote ? (
                                    <Grid item xs={12} id="pmd_Grid_4">
                                        <FormControl variant="outlined" style={{ width: "90%", marginTop: 15 }}>
                                            <TextField
                                                id="pmd_TextField"
                                                label={t("Note")}
                                                variant="outlined"
                                                multiline
                                                value={notes}
                                                defaultValue={notes}
                                                onChange={handleNotes}
                                                disabled={disableNote}
                                            />
                                        </FormControl>
                                    </Grid>
                                ) : null}
                                <Grid item xs={12} align="center" id="pmd_Grid_5">
                                    <Accordion id="pmd_accordion" style={{ width: "90%", marginTop: 15 }}>
                                        <AccordionDetails>
                                            <Grid container id="pmd_Grid_6">
                                                {hasSparePart ? (
                                                    <Grid item id="bd_spare_part_grd" xs={12}>
                                                        <Button id="bd_sparePart_btn" variant="contained" color={"primary"} style={{ width: "100%" }} onClick={HandleSparePartOpen}>
                                                            {t("AddSparePart")}
                                                        </Button>
                                                    </Grid>
                                                ) : visibleSparePart ? (
                                                    <Grid item xs={12} id="pmd_Grid_7">
                                                        <FormControl variant="outlined" style={{ width: "100%", marginTop: 15 }}>
                                                            <TextField
                                                                id="pmd_textField_1"
                                                                align="left"
                                                                label={t("SparePart")}
                                                                variant="outlined"
                                                                multiline
                                                                value={sparePart}
                                                                defaultValue={sparePart}
                                                                onChange={handleSparePart}
                                                                disabled={disableSparePart}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                ) : null}

                                                <Grid id="amd_Grid_" item xs={12}>
                                                    <Button
                                                        id="amd_Button"
                                                        disabled={disableTaskCheckItemsButton}
                                                        style={{ width: "80%", marginTop: 15, marginBottom: 10 }}
                                                        onClick={() => history.push("/planned-task-check-list?id=" + rows.id, { isTaskStarted: disableAssignButton })}
                                                        variant="contained"
                                                        color="secondary"
                                                        startIcon={<PlaylistAddCheckRoundedIcon />}
                                                    >
                                                        {t("CheckItems")}
                                                    </Button>
                                                </Grid>
                                                <Grid id="bd_grid_9" item xs={3}>
                                                    <IconButton id="bd_iconBtn_2" onClick={HandleOrderFormOpen} size="large">
                                                        <Assignment id="bd_orderForm" sx={iconButtonStyle} className={classes.orderFormButtonStyle} />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs={3} id="pmd_Grid_8">
                                                    <IconButton id="pmd_iconButton_1" onClick={handleTimelineOpen} size="large">
                                                        <Timelapse id="pmd_timeLapse" sx={iconButtonStyle} style={{ fill: "#757575" }} />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs={3} id="pmd_Grid_9">
                                                    <Tooltip title={t("ShowFiles")}>
                                                        <IconButton id="pmd_iconButton_2" onClick={handleDocumentOpen} size="large">
                                                            <CloudDownload id="pmd_cloudDownload" sx={iconButtonStyle} style={{ fill: "#757575" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item xs={3} id="pmd_Grid_10">
                                                    <Tooltip title={t("UploadFile")}>
                                                        <IconButton
                                                            id="pmd_iconButton_3"
                                                            component="label"
                                                            disabled={disableDocumentButton}
                                                            onClick={() => setIsFileUploaderPopupOpen(true)}
                                                            size="large"
                                                        >
                                                            <CloudUpload id="pmd_cloudUpload" sx={iconButtonStyle} style={{ fill: "#757575" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                {visibleEnvCheckbox ? (
                                    <Grid id="bd_grid_13" item xs={12} align="center" style={{ marginTop: 15 }}>
                                        <FormControlLabel
                                            id="bd_formControlLabel"
                                            disabled={disableEnvCheckbox}
                                            control={<Checkbox id="bd_isEnvNotCleanCheckbox" color="success" checked={isEnvNotClean} onChange={(event) => setIsEnvNotClean(event.target.checked)} />}
                                            label={
                                                <Typography id="bd_typ_2" fontSize={13}>
                                                    {t("EnvironmentallyUnsuitable")}
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                ) : null}
                                <Grid id="bd_grid_20" item xs={12} align="center" style={{ marginTop: 15 }}>
                                    <Button id="bd_Eked_Detail_Button" variant="contained" color={ekedUsed ? "primary" : "error"} style={{ width: "90%" }} onClick={EkedEquipmentPopupHandler}>
                                        {ekedUsed ? t("EkedIsUsing") : t("EkedIsNotUsing")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {securityDialogOpen === true ? (
                        <SecurityPopup
                            disabledEked={disabledEked}
                            securityDialogOpen={securityDialogOpen}
                            HandleSecurityDialogClose={HandleSecurityDialogClose}
                            HandleSecurityDialogConfirm={HandleSecurityDialogConfirm}
                            HandleEkedEquipment={HandleEkedEquipment}
                            selectedEkedEquipmentIds={selectedEkedEquipmentIds}
                            setSelectedEkedEquipmentNames={setSelectedEkedEquipmentNames}
                            setTempEkedEquipmentIds={setTempEkedEquipmentIds}
                            tempEkedEquipmentIds={tempEkedEquipmentIds}
                            tempEkedEquipmentNames={tempEkedEquipmentNames}
                            setTempEkedEquipmentNames={setTempEkedEquipmentNames}
                            isChecked={isChecked}
                            setIsChecked={setIsChecked}
                        />
                    ) : null}
                    {userIList.includes("VIEWER") ? null : (
                        <Box id="pmd_Box_1">
                            <Grid container alignItems="flex-end" wrap="nowrap" id="pmd_Grid_11">
                                <Grid item xs={3} id="pmd_Grid_12">
                                    <IconButton id="pmd_IconButton_4" onClick={() => assignToMe(rows)} disabled={disableAssignButton} className={classes.iconButtonLabel} size="large">
                                        <AccountCircle id="pmd_accountCircle" sx={iconButtonStyle} style={{ fill: "#536dfe" }} />
                                        <Typography id="pmd_Typography" variant="subtitle2">
                                            {t("AssignToMe")}
                                        </Typography>
                                    </IconButton>
                                </Grid>
                                {rows.taskStatus == 1 || rows.taskStatus == 2 || rows.taskStatus == 4 ? (
                                    <Grid item xs={3} id="pmd_Grid_13">
                                        <IconButton id="pmd_IconButton_5" onClick={() => startTask(rows)} disabled={disableStartButton} className={classes.iconButtonLabel} size="large">
                                            <PlayCircleFilledWhite id="pmd_playCircle" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                                            <Typography id="pmd_Typography_1" variant="subtitle2">
                                                {t("Start")}
                                            </Typography>
                                        </IconButton>
                                    </Grid>
                                ) : rows.taskStatus == 3 ? (
                                    <Grid item xs={3} id="pmd_Grid_14">
                                        <IconButton id="pmd_IconButton_6" onClick={openPausePopup} disabled={disablePauseButton} className={classes.iconButtonLabel} size="large">
                                            <PauseCircleFilled id="pmd_pauseCircle" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                                            <Typography id="pmd_Typography_2" variant="subtitle2">
                                                {t("Pause")}
                                            </Typography>
                                        </IconButton>
                                    </Grid>
                                ) : (
                                    <Grid item xs={3} id="pmd_Grid_15">
                                        <IconButton id="pmd_IconButton_7" onClick={() => updateTask(rows)} disabled={disableStartButton} className={classes.iconButtonLabel} size="large">
                                            <Save id="pmd_Save" sx={iconButtonStyle} style={{ fill: "#fbc02d" }} />
                                            <Typography id="pmd_Typography_3" variant="subtitle2">
                                                {t("Save")}
                                            </Typography>
                                        </IconButton>
                                    </Grid>
                                )}
                                {rows.taskStatus != 5 && rows.taskStatus != 6 ? (
                                    <Grid item xs={3} id="pmd_Grid_16">
                                        <IconButton id="pmd_IconButton_8" onClick={() => completeTask(rows)} disabled={disableFinishButton} className={classes.iconButtonLabel} size="large">
                                            <CheckCircle id="pmd_checkCircle" sx={iconButtonStyle} style={{ fill: "#4caf50" }} />
                                            <Typography id="pmd_Typography_4" variant="subtitle2">
                                                {t("Complete")}
                                            </Typography>
                                        </IconButton>
                                    </Grid>
                                ) : (
                                    <Grid item xs={3} id="pmd_Grid_17">
                                        <IconButton id="pmd_IconButton_9" onClick={() => completeTask(rows)} disabled={disableFinishButton} className={classes.iconButtonLabel} size="large">
                                            <OfflinePin id="pmd_offlinePin" sx={iconButtonStyle} style={{ fill: "#4caf50" }} />
                                            <Typography id="pmd_Typography_5" variant="subtitle2">
                                                {t("Close")}
                                            </Typography>
                                        </IconButton>
                                    </Grid>
                                )}
                                <Grid item xs={3} style={{ position: "relative" }} id="pmd_Grid_18">
                                    <Backdrop id="pmd_backDrop" open={openSpeedDial} className={classes.backdrop} />
                                    <SpeedDial
                                        id="pmd_speedDial"
                                        ariaLabel="SpeedDial"
                                        direction="up"
                                        className={classes.speedDial}
                                        icon={<SpeedDialIcon />}
                                        onClose={handleCloseSpeedDial}
                                        onOpen={() => handleOpenSpeedDial(rows)}
                                        open={openSpeedDial}
                                    >
                                        {actions.map((action, index) => (
                                            <SpeedDialAction
                                                id={`pmd_speedDialAction_${index}`}
                                                key={action.name}
                                                icon={action.icon}
                                                tooltipTitle={action.name}
                                                tooltipOpen={true}
                                                classes={classTooltip}
                                                onClick={action.action}
                                            />
                                        ))}
                                    </SpeedDial>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {breakdownDetailPopup === true ? (
                        <Container id="pmd_Container_1">
                            <Dialog id="pmd_Dialog" open={breakdownDetailPopup} onClose={handleBreakdownDetailClose} fullWidth="xs">
                                <DialogTitle id="pmd_dialogTitle">{t("BreakdownDetail")}</DialogTitle>
                                <DialogContent id="pmd_dialogContent">
                                    <form>
                                        <FormControl id="pmd_formControl" variant="outlined" className={classes.popupElement}>
                                            <InputLabel>{t("BreakdownGroup")}</InputLabel>
                                            <Select id="pmd_Select" label={t("BreakdownGroup")} value={selectedBreakdownReasonGroupFilter} onChange={handleBreakdownReasonGroupFilter}>
                                                {breakdownReasonGroupDataFilter.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl id="pmd_formControl_1" variant="outlined" className={classes.popupElement}>
                                            <InputLabel>{t("BreakdownPlace")}</InputLabel>
                                            <Select id="pmd_Select_1" label={t("BreakdownPlace")} value={selectedBreakdownReasonPlaceCode} onChange={handleBreakdownReasonPlace}>
                                                {breakdownReasonPlace.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl id="pmd_formControl_2" variant="outlined" className={classes.popupElement}>
                                            <InputLabel>{t("BreakdownDetail")}</InputLabel>
                                            <Select id="pmd_Select_2" label={t("BreakdownDetail")} value={selectedBreakdownReasonDetailCode || ""} onChange={handleBreakdownReasonDetail}>
                                                {breakdownReasonDetail.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button id="pmd_Button" onClick={handleBreakdownDetailClose} color="primary">
                                        {t("Close")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Container>
                    ) : null}

                    {openAddFriendPopup === true && rows.taskStatus !== 5 ? (
                        <Container id="pmd_Container_2">
                            <Dialog id="pmd_Dialog_1" open={openAddFriendPopup} onClose={closeAddFriendPopup} fullWidth="xs">
                                <DialogTitle id="pmd_dialogTitle_1">{t("AddFriend")}</DialogTitle>
                                <DialogContent id="pmd_dialogContent_1">
                                    <form>
                                        <FormControl id="pmd_formControl_3" variant="outlined" className={classes.popupElement}>
                                            <InputLabel>{t("Persons")}</InputLabel>
                                            <Select id="pmd_Select_3" label={t("Persons")} value={selectedFriend} onChange={(event) => setSelectedFriend(event.target.value)}>
                                                {addFriendUserData != null
                                                    ? addFriendUserData.map((data) => (
                                                          <MenuItem key={data.userCode} value={data.userCode}>
                                                              {data.userName}
                                                          </MenuItem>
                                                      ))
                                                    : null}
                                            </Select>
                                        </FormControl>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button id="pmd_Button_1" onClick={closeAddFriendPopup} color="primary">
                                        {t("Close")}
                                    </Button>
                                    <Button id="pmd_Button_2" disabled={addFriendUserData.length <= 0} onClick={() => addFriend(rows)} color="primary">
                                        {t("Add")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Container>
                    ) : null}

                    {editRequestPopup === true ? (
                        <Container id="pmd_Container_3">
                            <Dialog id="pmd_Dialog_2" open={editRequestPopup} onClose={cancelEditRequest} fullWidth="xs">
                                <DialogTitle id="pmd_dialogTitle_2">{t("EditJobOrder")}</DialogTitle>
                                <DialogContent id="pmd_dialogContent_2">
                                    <form>
                                        <FormControl id="pmd_formControl_4" variant="outlined" fullWidth margin="normal">
                                            <InputLabel>{t("Pool")}</InputLabel>
                                            <Select id="pmd_Select_4" label={t("Pool")} value={selectedPoolCode} onChange={handlePoolChange}>
                                                {poolData.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl id="pmd_formControl_5" variant="outlined" fullWidth="xs" margin="normal" >
                                            <Shift selectedShiftType={selectedShiftType} HandleShift={HandleShift} shiftData={shiftData} />
                                        </FormControl>
                                        <FormControl id="pmd_formControl_6" variant="outlined" fullWidth>
                                            <LocalizationProvider id="pmd_muiPickersUtilProvider" dateAdapter={AdapterDateFns} adapterLocale={tr}>
                                                <DatePicker
                                                    id="pmd_DatePicker"
                                                    disableToolbar
                                                    variant="inline"
                                                    renderInput={(_props) => <TextField {..._props} />}
                                                    inputFormat="dd.MM.yyyy"
                                                    value={plannedDate}
                                                    onChange={handlePlannedDateChange}
                                                    label={t("PlannedDate")}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                    minDate={new Date()}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button id="pmd_Button_3" onClick={cancelEditRequest} color="secondary">
                                        {t("Cancel")}
                                    </Button>
                                    <Button id="pmd_Button_4" onClick={() => updateTask(rows)} color="primary">
                                        {t("Confirm")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Container>
                    ) : null}

                    {assignPopup === true ? (
                        <Container id="pmd_Container_4">
                            <Dialog id="pmd_Dialog_3" open={assignPopup} onClose={cancelAssign} fullWidth="xs">
                                <DialogTitle id="pmd_dialogTitle_3">{t("AssigntoAnotherPerson")}</DialogTitle>
                                <DialogContent id="pmd_dialogContent_3">
                                    <form>
                                        <FormControl id="bd_fromControl_10" variant="outlined" className={classes.popupElement}>
                                            <Autocomplete
                                                id="pmd_autoComplete_1"
                                                defaultValue={""}
                                                style={{ marginTop: -10 }}
                                                onChange={(event, newValue) => {
                                                    handleUserChange(newValue);
                                                }}
                                                options={userData.map((option) => option.userName)}
                                                renderInput={(params) => <TextField id="bd_textFiled_21" {...params} margin="normal" label={t("Persons")} variant="outlined" />}
                                            />
                                        </FormControl>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button id="pmd_Button_5" onClick={cancelAssign} color="primary">
                                        {t("Cancel")}
                                    </Button>
                                    <Button id="pmd_Button_6" onClick={() => assignToSomeone(rows)} color="primary">
                                        {t("Confirm")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Container>
                    ) : null}

                    {openCancelTaskPopup === true ? (
                        <Container id="pmd_Container_5">
                            <Dialog id="pmd_Dialog_4" open={openCancelTaskPopup} onClose={closeCancelPopup} fullWidth="xs">
                                <DialogContent id="pmd_dialogContent_4">
                                    <DialogContentText id="alert-dialog-slide-description">{t("CancelTask")}</DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button id="pmd_Button_7" onClick={closeCancelPopup} color="secondary" variant="contained">
                                        {t("Cancel")}
                                    </Button>
                                    <Button id="pmd_Button_8" onClick={deleteOnce} color="primary" variant="contained">
                                        {t("OnlyThis")}
                                    </Button>
                                    <Button id="pmd_Button_9" onClick={deleteAll} color="primary" variant="contained">
                                        {t("All")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Container>
                    ) : null}

                    {pausePopup === true ? (
                        <Container id="pmd_Container_6">
                            <Dialog id="pmd_Dialog_5" open={pausePopup} onClose={closePausePopup} fullWidth="xs">
                                <DialogTitle id="pmd_dialogTitle_4">{t("Pause")}</DialogTitle>
                                <DialogContent id="pmd_dialogContent_5">
                                    <form>
                                        <FormControl id="pmd_formControl_8" variant="outlined" className={classes.popupElement}>
                                            <Autocomplete
                                                id="pmd_MaintenancePauseReasonArea"
                                                defaultValue={""}
                                                style={{ marginTop: -10 }}
                                                onChange={(event, newValue) => {
                                                    handleMaintenancePauseReason(newValue);
                                                }}
                                                options={maintenancePauseReasonData.map((option) => option.name)}
                                                renderInput={(params) => <TextField id="bd_textFiled_25" {...params} margin="normal" label={t("MaintenancePauseReason")} variant="outlined" />}
                                            />
                                            {/* <InputLabel>{t("MaintenancePauseReason")}</InputLabel>
                                            <Select
                                                id="pmd_MaintenancePauseReasonArea"
                                                label={t("MaintenancePauseReason")}
                                                value={selectedMaintenancePauseReasonCode}
                                                onChange={handleMaintenancePauseReason}
                                            >
                                                {maintenancePauseReasonData.map((data) => (
                                                    <MenuItem key={data.id} value={data.id}>
                                                        {data.name}
                                                    </MenuItem>
                                                ))}
                                            </Select> */}
                                        </FormControl>
                                        <TextField id="pmd_textField_2" onChange={handleMaintenancePauseNote} label={t("PauseNote")} variant="outlined" multiline className={classes.popupElement} />
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button id="pmd_Button_10" onClick={closePausePopup} color="primary">
                                        {t("Cancel")}
                                    </Button>
                                    <Button id="pmd_Button_11" onClick={() => pauseTask(rows)} color="primary">
                                        {t("Confirm")}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Container>
                    ) : null}

                    {timelinePopup === true ? <TimelinePopup id="pmd_TimelinePopup" array={timelineArray} open={timelinePopup} close={() => closeTimelinePopup()} /> : null}

                    {documentPopup === true ? (
                        <DocumentPopup
                            isMaintenanceDocuments={true}
                            isEquipmentDocuments={true}
                            id="pmd_documentPopup"
                            list={documentList}
                            equipmentDocuments={equipmentFiles}
                            open={documentPopup}
                            deleteFile={DeleteFile}
                            deleteEquipmentFiles={DeleteEquipmentFile}
                            close={() => closeDocumentPopup()}
                        />
                    ) : null}

                    {isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={isFileUploaderPopupOpen} onCancel={() => setIsFileUploaderPopupOpen(false)} onConfirm={UploadFiles} /> : null}
                </Container>
            ) : null}
            <LoadingBackdrop id="pmd_loadingBackdrop" />
        </div>
    );
}
